function hideOnClickOutside(selector) {
  let outsideClickListener = function (event) {
    let $target = $(event.target)

    if (!$target.closest(selector).length && $(selector).is(':visible')) {
      if (!$(document).find('.x-search-header-input').is(":focus")) {
        $(selector).hide()
      }
    }
  }

  document.addEventListener('click', outsideClickListener)
}

(function ($) {
  "use strict"

  let $searchModal = '.x-search-header-modal';
  let $searchResult = document.getElementById('search-header-result');
  if ($searchResult) {
    let $formSearch = $(document).find('.x-search-header-form')

    $formSearch.on('input', '.x-search-header-input', function () {
      let $modalSearch = $formSearch.parent('.x-search-header-box').find($searchModal),
        $target = $(event.target),
        query = $target.val().toUpperCase()

      if (query.length >= 2) {
        if (!$target.closest($searchModal).length) {
          if (!$modalSearch.is(':visible')) {
            setTimeout(function () {
              hideOnClickOutside($searchModal)
            }, 400)

            $modalSearch.fadeToggle()
          }
        }
      }
    })
  }
})(jQuery)
